<template>
  <div>
    <!-- Hero Section -->
    <section>
      <div class="hero-header w-full flex flex-col md:flex-row gap-12 items-center justify-center max-w-7xl mx-auto px-4">
        <div class="text-left w-full md:w-1/2">

          <div class="mb-6 pt-24 md:pt-0 flex justify-center md:justify-start">
            <span
              class="px-4 py-1 rounded-full text-sm font-semibold bg-secondary-50 text-secondary-500 border border-secondary-200">
              🎉 Celebrating 25 Years 🎉
            </span>
          </div>
          <div class="text-3xl md:text-5xl text-gray-800 font-headings text-center md:text-left">
            Beautiful, Flexible, Powerful event technology.
          </div>
          <div class="text-lg text-gray-700 mt-8 font-body leading-6">
            A ground-up, single source of truth platform forged from 25 years of event technology experience. Designed
            as one unified system - seamless, cohesive, and built to scale.<br /><br />
            Our mission is to empower event organizers with the tools they need to bring their vision to life, while
            continuing to evolve and shape our industry.
          </div>
          <div class="flex flex-row gap-4 mt-8">
            <a href='/signup' class="inline-flex"><Button text="Sign up Now" variant="accent" hasArrow size="md" /></a>
            <a href='/contact' class="inline-flex"><Button text="Talk to our team" variant="primary" size="md" /></a>
          </div>
        </div>
        <div class="hidden md:block md:w-1/2">
          <Pattern :cols="5" :rows="4" />
        </div>

      </div>
    </section>

    <section class="z-20 relative text-center ">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 md:mt-0">
        <div class="grid grid-cols-2 md:grid-cols-4">
          <div class="py-2 md:py-8">
            <div class="text-2xl md:text-4xl font-headings text-primary-500">25 Years</div>
            <div>founded in 2001</div>
          </div>
          <div class="border-l border-r border-gray-300 py-2 md:py-8">
            <div class="text-2xl md:text-4xl font-headings text-primary-500">8,500,000+</div>
            <div>attendees</div>
          </div>
          <div class="border-l border-r border-gray-300 py-2 md:py-8">
            <div class="text-2xl md:text-4xl font-headings text-primary-500">12,500+</div>
            <div>events</div>
          </div>
          <div class="py-2 md:py-8">
            <div class="text-2xl md:text-4xl font-headings text-primary-500">85+</div>
            <div>countries</div>
          </div>
        </div>
      </div>
    </section>

    <div style="background: linear-gradient(180deg, #ffffff 0%, #e6e2fe 60%);" class="py-24">
      <PlatformOverview />
    </div>

    <div class="py-12">
      <WhyEntegy />
    </div>

    <IsoCertified />

    <Cta />

    <div class="py-12 stacked-linear bg-no-repeat relative">
      <div class="h-full w-full absolute top-0 left-0 z-20 w-full bg-no-repeat"
        style="background-position: right 16px bottom 16px; background-size: 200px; background-image: url('https://labs.entegy.com.au/entegy/rocket.svg')">
      </div>
      <Testimonials />
    </div>

    <DIY />

    <CtaSignup />
  </div>
</template>

<script setup>
import Pattern from '../components/Pattern.vue';
import Button from '../components/Buttons/Button.vue';
import PlatformOverview from '../components/PlatformOverview.vue';
import IsoCertified from '../components/IsoCertified.vue';
import WhyEntegy from '../components/Sections/WhyEntegy.vue';
import Testimonials from '../components/Testimonials.vue';
import DIY from '../components/DIY.vue';
import Cta from '../components/Blocks/Cta.vue';
import CtaSignup from '../components/Blocks/CtaSignup.vue';
// About page component
</script>


<style>
.stacked-linear {
  background:
    linear-gradient(217deg, #4f39f6, transparent 70.71%),
    linear-gradient(127deg, #7d38ff, transparent 70.71%),
    linear-gradient(336deg, #ff69b2, transparent 70.71%);
  background-size: 200% 200%;
  animation: gradientShift 10s ease infinite;
}

.gradient-light-radial {
  background: radial-gradient(circle, #ffffff 50%, #e6e2fe 90%);
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.entegy-pill-large {
  border-top-right-radius: 48px;
  border-bottom-left-radius: 48px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.entegy-pill-small {
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

@media (min-width: 767px) {
  .hero-header {
    height: calc(100vh - 100px);
    max-height: 800px;
    min-height: 500px;
  }
}
</style>